import React, { useEffect, useState } from "react";

import {
    EuiButtonIcon,
    EuiFieldSearch,
    EuiFilterSelectItem,
    EuiLoadingSpinner,
    EuiPopover,
    EuiPopoverTitle,
} from "@elastic/eui";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import tripActions from "../../configs/tripActions";
import Api from "../../../../lib/api";
import { mapResourceObjectToArray } from "../../../../utils/jsonApiUtils";
import { TripActionsContextMenuWrapper } from "../../style";

const renderMenuButton = ({ isLoading, onClick }) =>
    !isLoading ? (
        <EuiButtonIcon
            aria-label="Actions"
            iconType="boxesHorizontal"
            size="m"
            style={{ color: "white" }}
            onClick={onClick}
        />
    ) : (
        <EuiLoadingSpinner size="m" />
    );

const generateActionPanelItems = (onSelectAction) => [
    ...tripActions.map((action) => ({
        name: <FormattedMessage id={`trip.status-${_.kebabCase(action.value)}`} />,
        onClick: () => {
            onSelectAction(action.value);
        },
        icon: action.icon,
    })),
    { name: <FormattedMessage id="trip.add-tags-title" />, panel: 1, icon: "tag" },
];

const generatePanels = ({ onSelectAction, tags, onSelectTag, onTagsSearch, isStatusEditable }) =>
    renderPanels(onSelectAction, tags, onSelectTag, onTagsSearch, isStatusEditable);

const renderPanels = (onSelectAction, tags, onSelectTag, onTagsSearch, isStatusEditable) => {
    const panels = [
        {
            id: isStatusEditable ? 1 : 0,
            title: <FormattedMessage id="trip.tags-title" />,
            content: (
                <>
                    <EuiPopoverTitle paddingSize="s">
                        <EuiFieldSearch
                            compressed
                            placeholder="Search tags..."
                            onChange={(e) => onTagsSearch(e.target.value)}
                            isClearable
                            aria-label="search tags"
                        />
                    </EuiPopoverTitle>
                    <div className="euiFilterSelect__items">
                        {tags.map((item, index) => (
                            <EuiFilterSelectItem
                                checked={item.checked}
                                key={index}
                                onClick={() => onSelectTag(item.name)}
                            >
                                {item.name}
                            </EuiFilterSelectItem>
                        ))}
                    </div>
                </>
            ),
        },
    ];

    isStatusEditable &&
        panels.unshift({
            id: 0,
            items: generateActionPanelItems(onSelectAction),
        });

    return panels;
};

const toFilterListTags = (tags, selectedTags) =>
    tags.map((tag) => ({
        name: tag,
        checked: selectedTags.includes(tag) ? "on" : null,
    }));

const fetchTags = async (searchString) => {
    const { entities } = await Api.get(`/tags${searchString ? `?filter[q]=${searchString}` : ""}`);

    return entities.tags;
};

function TripActions({ isSaving, onConfirm, selectedTags = [], onSelectTag, isStatusEditable }) {
    const [isOpen, setisOpen] = useState(false);
    const [tags, setTags] = useState([]);

    useEffect(() => {
        getTags();
    }, []);

    const getTags = async (searchString) => {
        const data = await fetchTags(searchString);
        const tagNames = mapResourceObjectToArray(data).map((item) => item.name);

        setTags(tagNames);
    };

    const handleSelectTag = (selectedTag) => {
        const selectedTagsClone = [...selectedTags];
        const index = selectedTags.indexOf(selectedTag);

        if (index > -1) {
            selectedTagsClone.splice(index, 1);
        } else {
            selectedTagsClone.push(selectedTag);
        }

        onSelectTag(selectedTagsClone);
    };

    const handleTagsSearch = _.debounce((searchString) => {
        getTags(searchString);
    }, 500);

    return (
        <EuiPopover
            button={renderMenuButton({ isLoading: isSaving, onClick: () => setisOpen(!isOpen) })}
            isOpen={isOpen}
            closePopover={() => setisOpen(false)}
            panelPaddingSize="none"
            anchorPosition="rightUp"
        >
            <TripActionsContextMenuWrapper
                initialPanelId={0}
                panels={generatePanels({
                    onSelectAction: (actionValue) => onConfirm(actionValue),
                    onSelectTag: (tagName) => handleSelectTag(tagName),
                    onTagsSearch: (searchString) => handleTagsSearch(searchString),
                    isStatusEditable,
                    tags: toFilterListTags(tags, selectedTags),
                })}
            />
        </EuiPopover>
    );
}

export default TripActions;
